import React, { useState, useEffect } from "react";
import "./TemplateModal.css";

export default function TemplateModal({ open, onClose, onSubmit }) {
  const [templates, setTemplates] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [enableBatchName, setEnableBatchName] = useState(false);
  const [batchName, setBatchName] = useState("");

  // Fetch API khi mở popup
  useEffect(() => {
    if (open) {
      fetch("https://api.ocr.cybertech.com.vn/packages")
        .then((res) => res.json())
        .then((data) => setTemplates(data))
        .catch((err) => console.log("Error fetch templates:", err));
    }
  }, [open]);

  if (!open) return null;

  // Lấy template được chọn
  const chosenTemplate = templates.find((t) => t._id === selectedId);

  return (
    <div className="modal-overlay">
      <div className="modal-box">

        <h3 className="modal-title">Tạo mới gói tài liệu</h3>

        {/* Dropdown 1: Phân loại tài liệu */}
        <div className="form-group">
          <label>Phân loại tài liệu:</label>

          <select
            value={selectedId}
            onChange={(e) => setSelectedId(e.target.value)}
          >
            <option value="">-- Chọn loại --</option>

            {templates.map((t) => (
              <option key={t._id} value={t._id}>
                {t.name}
              </option>
            ))}
          </select>
        </div>

        {/* Dropdown 2: Danh sách mẫu (sample) */}
        <div className="form-group">
          <label>Danh sách mẫu:</label>

          <select disabled={!selectedId}>
            {!selectedId && <option>-- Chưa chọn loại --</option>}
            {selectedId && <option>{chosenTemplate?.sample}</option>}
          </select>
        </div>

        {/* Checkbox + batch name */}
        <div className="form-group checkbox-row">
          <input
            type="checkbox"
            checked={enableBatchName}
            onChange={() => setEnableBatchName(!enableBatchName)}
          />
          <label>Nhập tên gói tài liệu</label>
        </div>

        {enableBatchName && (
          <input
            className="text-input"
            placeholder="Nhập tên gói tài liệu"
            value={batchName}
            onChange={(e) => setBatchName(e.target.value)}
          />
        )}

        {/* Buttons */}
        <div className="modal-actions">
          <button
            className="btn-primary"
            onClick={() => {
              if (!selectedId) return;

              onSubmit({
                templateId: selectedId,   // giữ lại _id
                name: chosenTemplate.name,
                sample: chosenTemplate.sample,
                batchName,
              });
              onClose();
            }}
          >
            Chọn
          </button>

          <button className="btn-secondary" onClick={onClose}>
            Thoát
          </button>
        </div>
      </div>
    </div>
  );
}
